import { makeStyles } from "@material-ui/styles"
import { MAX_PAGE_WIDTH } from "@styles/themes";

const useStyle = makeStyles((theme) => ({
  root: {
    marginTop: 0,
    boxSizing: "border-box",
    width: MAX_PAGE_WIDTH,
    // padding: "0 8px",
  },
  mobileColumnContainer: {
    height: theme.props.contentHeight,
    boxSizing: "border-box",
    "@media (max-width: 520px)": {
      width: "300vw !important",
    },
  },
  sharedEmptyMessageContainer: {
    textAlign: "center",
    maxWidth: 480,
    margin: "80px auto 0",
  },
  // sharedEmptyImage: {
  //   width: 280,
  //   maxWidth: "100%",
  //   marginBottom: 32,
  // },
  sharedEmptyMessageDescription: {
    fontSize: 15,
    color: theme.props.text.secondary,
    lineHeight: 1.6,
    margin: 0,
  },
}));

export default useStyle;
